import { render, staticRenderFns } from "./rfq.vue?vue&type=template&id=5905855b&"
import script from "./rfq.vue?vue&type=script&lang=js&"
export * from "./rfq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "rfq.vue"
export default component.exports